module.exports = "label {\n  font-weight: bold; }\n\n.card {\n  width: 60%; }\n\n.mask {\n  padding: 50px; }\n\n@media (max-width: 576px) {\n  .mask {\n    padding: 10px; }\n  .card {\n    width: 100%; } }\n\n@media (min-width: 576px) and (max-width: 768px) {\n  .mask {\n    padding: 10px; }\n  .card {\n    width: 100%; } }\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/componentes/form/form.component.scss
// module id = ./src/app/componentes/form/form.component.scss
// module chunks = main